import axios from 'axios'
import * as Sentry from '@sentry/browser';

// import {message} from 'ant-design-vue'
// import {jump} from './jump'
import {util} from './index'
// axios.defaults.withCredentials=true;//让ajax携带cookie
const $ajax= axios.create({
    withCredentials:true
});
$ajax.interceptors.request.use(config=> {
    // Do something before request is sent
    return config;
  }, error=> {
    // Do something with request error
    return Promise.reject(error);
  });

// Add a response interceptor
$ajax.interceptors.response.use(response =>{
  // Do something with response data
  const { data } = response
//   if (data) {
//     const { code, msg } = data
//     if (code * 1 !== 1) {
//       if (code * 1 === 3 || code * 1 === 4) {
//         util.clearCookies()
//         jump.login()
//         message.error(msg)
//       }
//     }
//   }
    return response && response.data ? response.data : response;
  }, error => {
    const config = error.config || {}
    Sentry.withScope(scope => {
      scope.setExtras({
        url: config.url,
        responseBody: error.response
      })
      Sentry.captureException(error)
    })
    //message.error(error.toString());
    return null;
  });

  const ajax= axios.create();

  ajax.interceptors.response.use(response =>{
    const { data,config } = response
    if (data && config.url.indexOf('portal.haiziwang.com/portal-api') > -1) {
      const { code } = data
      if (code * 1 !== 1) {
        if (code * 1 === 3 || code * 1 === 4) {
          util.clearCookies()
          Sentry.withScope(scope => {
            scope.setExtras({
              url: response.config.url,
              responseBody: response
            })
            Sentry.captureException(new Error('未登陆'))
          })
        }
      }
    }
    return response && response.data ? response.data : response;
  }, error => {
    const config = error.config || {}
    Sentry.withScope(scope => {
      scope.setExtras({
        url: config.url,
        responseBody: error.response
      })
      Sentry.captureException(error)
    })
    //message.error(error.toString());
    return null;
  });

export const $http = $ajax;//拦截款1 :拦截登录
export const http = ajax;//拦截款2  :不拦截登录

